import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ConflictsModel } from '@library/core-models/src/conflicts.model';
import { reorderArray } from '@library/core-models/src/reorderable.model';
import { LifeSectionValidation } from '@library/plugin-life-section/src/lib/life-section.validation';
import { ValueRequiredValidator } from '@core/validation';
import { AlertController } from '@ionic/angular';

@Component({
    selector: 'plugin-life-section-conflicts',
    templateUrl: './life-section-conflicts.component.html'
})
export class LifeSectionConflictsComponent implements OnInit {
    @Output() itemsChange = new EventEmitter<ConflictsModel[]>();
    @Input() get items(): ConflictsModel[] { return this.itemsValue }

    itemsValue: ConflictsModel[];

    item: ConflictsModel = {};

    constructor(private validation: LifeSectionValidation, private alertController: AlertController) { }

    set items(val: ConflictsModel[]) {
        this.itemsValue = val;
        this.itemsChange.emit(this.itemsValue);
    }

    reorder(e) {
        this.items = reorderArray(this.items, e.detail['from'], e.detail['to']);
        e.detail.complete();
    }

    add() {
        let valid = this.validation.validateSingle(this.item, new ValueRequiredValidator(), 'Stolperstein und Abhilfe müssen angegeben werden.');
        if (!valid)
            return;

        valid = this.validation.validateSingle(this.item.text, new ValueRequiredValidator(), 'Stolperstein darf nicht leer sein.');
        if (!valid)
            return;

        valid = this.validation.validateSingle(this.item.solution, new ValueRequiredValidator(), 'Abhilfe darf nicht leer sein.');
        if (!valid)
            return;

        this.items.forEach(x => x.index++);

        let result = [];
        result.push({
            text: this.item.text,
            solution: this.item.solution,
            index: 0
        });
        result.push(...this.items);
        this.items = result;
        this.item.text = '';
        this.item.solution = '';
    }

    delete(idx) {
        let result = this.items.filter(x => x.index !== idx);

        let index = 0;
        result.forEach(x => x.index = index++);
        this.items = result;
    }

    edit(idx) {
        this.alertController.create({
            header: 'Stolperstein und Abhilfe ändern',
            inputs: [
                {
                    name: 'text',
                    type: 'text',
                    placeholder: 'Neuer Stolperstein',
                    value: this.items[idx].text
                },
                {
                    name: 'solution',
                    type: 'text',
                    placeholder: 'Neue Abhilfe',
                    value: this.items[idx].solution
                }
            ],
            buttons: [
                { text: 'Abbrechen', role: 'cancel' },
                {
                    text: 'Speichern', handler: (value) => {
                        if (!value.text || !value.solution) {
                            this.openEditErrorAlert(idx);
                            return;
                        }
                        this.items[idx].text = value.text;
                        this.items[idx].solution = value.solution;
                    }
                }
            ]
        }).then(async alert => await alert.present());
    }

    openEditErrorAlert(idx) {
        this.alertController.create({
            message: 'Das Feld darf nicht leer sein! Bitte füllen Sie das Feld aus.',
            buttons: [
                { text: 'Verstanden', role: 'cancel' },
            ]
        }).then(async (alert) => {
            await alert.present();
            alert.onDidDismiss().then(() => {
                this.edit(idx);
            });
        });
    }

    ngOnInit() { }
}
